import { render, staticRenderFns } from "./RecentGalleryActivities.vue?vue&type=template&id=b7f51d72&scoped=true&"
import script from "./RecentGalleryActivities.vue?vue&type=script&lang=js&"
export * from "./RecentGalleryActivities.vue?vue&type=script&lang=js&"
import style0 from "./RecentGalleryActivities.vue?vue&type=style&index=0&id=b7f51d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f51d72",
  null
  
)

export default component.exports